import { useTranslation } from 'react-i18next'

import RadioGroup from '@/components/Button/RadioGroup'
import { useAppState } from '@/composables/useAppState'
import { AppChooseEvent } from '@/state/AppEvent'
import { CompletionStatus } from '@/state/AppStateMachine'

export type SummaryHeaderNavProps = {
  leaving?: boolean
}

export default function SummaryHeaderNav({ leaving }: SummaryHeaderNavProps) {
  const { t } = useTranslation()

  const { actor, persona, scenario, summary } = useAppState()

  const choices = scenario.status
    .filter((status) => status === CompletionStatus.COMPLETED)
    .map((_, index) => {
      return {
        value: `${index}`,
        label: t(`scenario.${persona}.${index + 1}.title`),
        checked: index === summary.scenario,
      }
    })

  return (
    choices.length > 1 && (
      <header
        className={`Header fixed z-80 bottom-0 md:bottom-auto md:top-0 left-0 w-full px-32 pb-16 md:pb-0 pt-0 md:pt-88 pointer-events-none *:pointer-events-auto flex justify-center ${leaving ? 'transition-opacity duration-500 ease-out-quad opacity-0' : '0'}`}
      >
        <RadioGroup
          is='nav'
          hasParticles={true}
          onChange={(choice: string) => actor.send({ type: 'CHOOSE', scenario: parseInt(choice) } as AppChooseEvent)}
          className='flex gap-8 md:gap-40'
          choices={choices}
          name='summary'
          classNameButtonInner='min-w-150 md:min-w-240'
        />
      </header>
    )
  )
}
